import React from 'react';
import { Container, Logo, Retangule } from './styles';
import LogoImage from '../../../assets/logomarca.png'




const Preloader: React.FC = () => {




    return (
        <Container>
            <Retangule>
                <a href="https://estudiocriar.com/" target="black">
                    <Logo src={LogoImage} />
                </a>
            </Retangule>
        </Container>
    );
};

export default Preloader